import { createAction } from 'redux-act';

export const goToBookingDetails = createAction<{
  bookingId: string;
  replace?: boolean;
}>('navigation/GO_TO_BOOKING_DETAILS');
